import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from 'react-schemaorg';


const getDrawImage = (type) => {
    switch (type) {
        case '9': return 'https://gulfticket.com/assets/img/past-draws/Fortune6.png';
        case '10': return 'https://gulfticket.com/assets/img/past-draws/super6.jpg';
        case '11': return 'https://gulfticket.com/assets/img/past-draws/magic-5.jpg';
        case '13': return 'https://gulfticket.com/assets/img/past-draws/lucky-1.jpg';
        case '14': return 'https://gulfticket.com/assets/img/past-draws/dream-5.jpg';
        case '15': return 'https://gulfticket.com/assets/img/past-draws/pick-3.png';
    }
};

// const getDrawTitle = (type) => {
//     switch (type) {
//         case '9': return 'Fortune6 6D Jackpot Live | Digit Match and Prize Structure | Gulf Ticket';
//         case '10': return 'Super6 6D Lucky Spin | Draw History nd Claim Info | Gulf Ticket';
//         case '11': return 'Magic5 5D Winning Board | Results Archive and Reward Breakdown | Gulf Ticket';
//         case '13': return 'Lucky1Draws Malaysia: Daily Live Draw Results & How to Win Big | Gulf Ticket';
//         case '14': return 'Dream5 5D Result Portal | Evening Draw Schedule and Prize Match | Gulf Ticket';
//         case '15': return '3D Rush3 Results Today | Game Summary and Winning Lineup | Gulf Ticket';
//     }
// };

const getDrawTitle = (type) => {
    switch (type) {
        case '9': return 'Fortune6 6D Draws Live Results | Digit Match and Prize Structure | Gulf Ticket';
        case '10': return 'Super6 6D Lucky Spin | Draw History and Claim Info | Gulf Ticket';
        case '11': return 'Magic5 5D Winning Board | Results and Reward Breakdown | Gulf Ticket';
        case '13': return 'Lucky1Draws Malaysia: Daily Live Draw Results & How to Win Big | Gulf Ticket';
        case '14': return 'Dream5 5D Result Portal | Evening Draw Schedule and Prize Match | Gulf Ticket';
        case '15': return '3D Rush3 Results Today | Game Summary and Winning Lineup | Gulf Ticket';
    }
};


const getKeyWords = (type) => {
    switch (type) {
        case '9': return 'online lottery Malaysia, live draw Malaysia';
        case '10': return 'Malaysia lotto results, Malaysia lottery jackpot';
        case '11': return 'online lottery Malaysia, live draw Malaysia';
        case '13': return 'live lottery results Malaysia, Malaysia lottery draw results';
        case '14': return 'latest lottery results Malaysia, lottery winning numbers Malaysia';
        case '15': return 'latest lottery results Malaysia, lottery winning numbers Malaysia';
    }
};

// const getDescription = (type) => {
//     switch (type) {
//         case '9': return "Explore 6D Fortune6 live results and the latest cash prize details. Watch for lucky numbers and win big at Gulf Ticket’s secure platform.";
//         case '10': return 'Get 6D Super6 instant draw results and lucky number combinations. Stay ahead with Gulf Ticket’s fast updates and daily prize info.';
//         case '11': return "Track 5D Magic5 live results, jackpot winners, and daily draw updates. Follow Gulf Ticket to see if your ticket scored the top prize.";
//         case '13': return "Explore GulfTicket's Lucky1Draws live results in Malaysia. Learn how to play, win, and maximize your chances—discover GulfTicket's referral games like Magic5, Super6, and Fortune6.";
//         case '14': return 'Check 5D Dream5 winning numbers online with live result updates. Find out today’s winners and next draw times only at Gulf Ticket.';
//         case '15': return "Watch 3D Rush3 live results and get real-time draw updates. See winning numbers instantly with Gulf Ticket and check your ticket today.";
//     }
// };

const getDescription = (type) => {
    switch (type) {
        case '9': return "Get live Fortune6 6D draw outcomes and prize match details. Review your winning digits and reward levels in real-time on Gulf Ticket.";
        case '10': return 'Check Super6 6D draw history, lucky spin numbers, and claim guidelines. Find updated results and prize levels directly through Gulf Ticket.';
        case '11': return "Find out if you matched the winning Magic5 5D numbers. Access the reward chart, draw results, and claim info easily at Gulf Ticket.";
        case '13': return "Explore GulfTicket's Lucky1Draws live results in Malaysia. Learn how to play, win, and maximize your chances—discover GulfTicket's referral games like Magic5, Super6, and Fortune6.";
        case '14': return 'View the latest Dream5 5D results and evening draw schedule. Match your numbers and see if you’ve won with Gulf Ticket’s result tracking portal.';
        case '15': return "Check today’s Rush3 3D game results, winning lineup, and payout updates. Track your digits instantly with Gulf Ticket's official draw summary.";
    }
};

function DrawsHelmetMy({ drawType }) {

    return (
        <div >
            <Helmet script={[
                helmetJsonLdProp({
                    "@context": "https://schema.org",
                    "@graph": [
                        {
                            "@type": "BreadcrumbList",
                            // "@id": "https://gulfticket.com/#breadcrumb",
                            itemListElement: [{ "@type": "ListItem", "position": 1, "name": "Draws" }]
                        },
                        {
                            "@type": "Organization",
                            "name": "Gulf Ticket",
                            "url": `${process.env.REACT_APP_DESKTOP_URL}/my-en/lottery-ticket/${drawType == 13 ? 'lucky1draws' : drawType == 15 ? 'rush3draws' : drawType == 14 ? 'dream5draws' : drawType == 11 ? 'magic5draws' : drawType == 11 ? 'fortune6draws' : drawType == 10 ? 'super6draws' : 'othersdraws'}`,
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://gulfticket.com/assets/img/logo.png?v0.3"
                            },
                            "sameAs": [
                                "https://www.facebook.com/gulfticketindia/",
                                "https://www.youtube.com/@gulfticket",
                                "https://x.com/gulfticketindia"
                            ],
                            "description": `Buy ${drawType == 13 ? 'Lucky1 1D' : drawType == 15 ? 'Rush3 3D' : drawType == 14 ? 'Dream5 5D' : drawType == 11 ? 'Magic5 5D' : drawType == 11 ? 'Fortune6 6D' : drawType == 10 ? 'Super6 6D' : 'Others'} Tickets Online in Malaysia and play daily for a chance to win big. Fast results, secure platform, and instant ticket confirmation. Join now on Gulf Ticket!`,
                            "keywords": `${drawType == 13 ? 'Lucky1 1D' : drawType == 15 ? 'Rush3 3D' : drawType == 14 ? 'Dream5 5D' : drawType == 11 ? 'Magic5 5D' : drawType == 11 ? 'Fortune6 6D' : drawType == 10 ? 'Super6 6D' : 'Others'}  lottery Malaysia, buy ${drawType == 13 ? 'Lucky1 1D' : drawType == 15 ? 'Rush3 3D' : drawType == 14 ? 'Dream5 5D' : drawType == 11 ? 'Magic5 5D' : drawType == 11 ? 'Fortune6 6D' : drawType == 10 ? 'Super6 6D' : 'Others'} tickets online, Malaysia lottery, 
                    AED ${drawType == 13 ? '5' : drawType == 15 ? '5' : drawType == 14 ? '10' : drawType == 11 ? '5' : drawType == 11 ? '10' : drawType == 10 ? '30' : '5'}, 
                    ${drawType == 13 ? 'Lucky1 1D' : drawType == 15 ? 'Rush3 3D' : drawType == 14 ? 'Dream5 5D' : drawType == 11 ? 'Magic5 5D' : drawType == 11 ? 'Fortune6 6D' : drawType == 10 ? 'Super6 6D' : 'Others'} lottery results, winning numbers, mega prize`
                        }]
                }),
            ]}>
                <title>{getDrawTitle(drawType)}</title>
                <meta name="description" content={getDescription(drawType)} />
                <meta name="keywords" content={getKeyWords(drawType)} />
                <meta property="og:title" content={getDrawTitle(drawType)} />
                <meta property="og:image" content={getDrawImage(drawType)} />
                <meta property="og:site_name" content="Gulf Ticket" />
                <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                <meta property="og:description" content={getDescription(drawType)} />
                <meta property="og:type" content="website" />
            </Helmet>
        </div>
    );
}

export default DrawsHelmetMy;
